<template>
  <div class="text-left">
    <div v-if="componentReady">
      <h5 v-text="t('xajax.newcontractor.server.IC_0063')"/>
      <hr>

      <div class="panel">
        <p v-text="t('xajax.newcontractor.server.IC_0064')"/>

        <p v-if="hasGe">
          <span v-text="t('xajax.clients.server.IC_0105')"/>
          <br>
          <span v-text="t('xajax.clients.server.IC_0106')"/>
          <a
            :href="t('ge.matrix.chart')"
            target="_blank">
            <img :src="t('ge.matrix.chart')">
          </a>
        </p>
      </div>

      <div
        v-for="employerData in subsetInfo.availableSubsets"
        class="panel">
        <h5 v-text="`${employerData.Name} (${employerData.Title})`"/>
        <strong
          :class="meetingRequirement(employerData)"
          v-text="`${t('register.min_selection')}: ${employerData.Min ? employerData.Min : t('register.not_available')}
            ${t('register.max_selection')}: ${employerData.Max ? employerData.Max : t('register.not_available')}`"/>

        <div class="row">
          <div class="small-12 medium-5 columns">
            <select
              v-model="subsetSelected[employerData.ID]"
              multiple
              size="10"
              @dblclick="addToSelected(employerData.ID)">
              <option
                v-for="subset in notSelected(employerData)"
                :value="subset.ID"
                v-text="subset.Name"/>
            </select>
          </div>

          <div class="small-12 medium-2 columns text-center show-for-medium-up">
            <div>
              <div style="top: 100px; position: relative;">
                <a
                  class="fa fa-angle-double-left fa-2x grow"
                  @click="removeFromSelected(employerData.ID)"/>
                <a
                  class="fa fa-angle-double-right fa-2x grow"
                  @click="addToSelected(employerData.ID)"/>
              </div>
            </div>
          </div>

          <div class="small-12 medium-2 columns text-center show-for-small-only">
            <div>
              <div style="position: relative;">
                <a
                  class="fa fa-angle-double-up fa-2x grow"
                  @click="removeFromSelected(employerData.ID)"/>
                <a
                  class="fa fa-angle-double-down fa-2x grow"
                  @click="addToSelected(employerData.ID)"/>
              </div>
            </div>
          </div>

          <div class="small-12 medium-5 columns">
            <select
              v-model="subsetCurrent[employerData.ID]"
              multiple
              size="10"
              @dblclick="removeFromSelected(employerData.ID)">
              <option
                v-for="subset in isSelected(employerData)"
                :value="subset.ID"
                v-text="subset.Name"/>
            </select>
          </div>
        </div>
      </div>

      <hr>

      <div class="row">
        <div class="columns large-3">
          <button
            class="tiny radius expand"
            @click="$emit('tab-change', 3)"
            v-text="t('courses.modal_previous')"/>
        </div>
        <div class="columns large-1">
          &nbsp;
        </div>
        <div class="columns large-4">
          <button
            @click="openGuide"
            class="tiny radius expand"
            v-text="t('register.user_guide')"/>
        </div>
        <div class="columns large-1">
          &nbsp;
        </div>
        <div class="columns large-3">
          <button
            class="tiny radius expand"
            @click="saveSubset"
            v-text="t('member_basic_edit.IC_0013')"/>
        </div>
      </div>
    </div>

    <div v-if="!componentReady">
      <i class="fa fa-spinner fa-spin fa-2x"/>
    </div>

  </div>

</template>

<script>
import _      from 'lodash';
import $      from 'jquery';
import toastr from 'toastr';

export default {

  props: ['displayData', 'geMemberIds'],

  data() {
    return {
      subsetInfo: {},
      componentReady: false,
      subsetSelected: {},
      subsetCurrent: {},
      atLeastOneSubetEmployerId: this.geMemberIds,
    };
  },

  computed: {
    hasGe() {
      let geFlag = false;

      _.forEach(this.subsetInfo.availableSubsets, (subsetGroup) => {
        if (_.includes(this.geMemberIds, subsetGroup.EmployerID) && geFlag === false) {
          geFlag = true;
        }
      });

      return geFlag;
    },
  },

  activated() {
    $.post('/register/tab-data/subset', (data) => {
      this.subsetInfo = data;
      this.componentReady = true;

      if (this.subsetInfo.availableSubsets.length === 0) {
        this.$emit('tab-change', 5);
      }

      _.forEach(this.subsetInfo.availableSubsets, (subsetGroup) => {
        this.subsetSelected[subsetGroup.ID] = [];
        this.subsetCurrent[subsetGroup.ID] = [];
      });
    }).fail( () => {
      window.location.href = '/register';
    });
  },

  methods: {
    openGuide() {
      window.open(t('register.user_guide_link'), '_blank')
    },

    meetingRequirement(subsetGroup) {
      const match = _.filter(subsetGroup.Subsets, subsets => !_.isEmpty(subsets.Selected));

      if ((!_.isEmpty(subsetGroup.Min) && _.size(match) < subsetGroup.Min)
          || (!_.isEmpty(subsetGroup.Max) && _.size(match) > subsetGroup.Max)) {
        return 'text-red';
      }

      return 'text-green';
    },

    saveSubset() {
      if (this.checkComplete()) {
        $.post('/register/save-subsets', {
          subsetInfo: this.subsetInfo.availableSubsets,
        })
          .done(() => {
            this.$emit('tab-change', 5);
          });
      }
    },

    checkComplete() {
      let complete = true;

      _.forEach(this.subsetInfo.availableSubsets, (subset) => {
        if (this.meetingRequirement(subset) === 'text-red') {
          complete = false;

          toastr.error(`${t('forms.legend_uptodate.IC_0238')} : ${subset.Name}`);
        }
      });

      _.forEach(this.atLeastOneSubetEmployerId, (employerId) => {
        const match = _.filter(this.subsetInfo.availableSubsets, subset => _.toNumber(subset.EmployerID) === employerId);

        if (!this.atLeastOneSelected(match) && !_.isEmpty(match)) {
          complete = false;

          toastr.error('You need to choice at least one from the list');
        }
      });

      return complete;
    },

    atLeastOneSelected(subsetGroups) {
      let complete = false;

      _.forEach(subsetGroups, (subsetGroup) => {
        _.forEach(subsetGroup.Subsets, (subset) => {
          if (subset.Selected) {
            complete = true;
          }
        });
      });

      return complete;
    },

    removeFromSelected(subsetGroupId) {
      const subsetList = this.subsetCurrent[subsetGroupId];
      const match = _.find(this.subsetInfo.availableSubsets, ({ ID }) => ID === subsetGroupId);

      _.forEach(match.Subsets, (subset) => {
        if (_.includes(subsetList, subset.ID)) {
          subset.Selected = null;
        }
      });
    },

    addToSelected(subsetGroupId) {
      const subsetList = this.subsetSelected[subsetGroupId];
      const match = _.find(this.subsetInfo.availableSubsets, ({ ID }) => ID === subsetGroupId);

      _.forEach(match.Subsets, (subset) => {
        if (_.includes(subsetList, subset.ID)) {
          subset.Selected = 'Selected';
        }
      });
    },

    notSelected(subsetGroup) {
      return _.filter(subsetGroup.Subsets, subset =>
        _.size(subset.Name) > 0 && _.size(subset.Selected) === 0);
    },

    isSelected(subsetGroup) {
      return _.filter(subsetGroup.Subsets, subset =>
        _.size(subset.Name) > 0 && _.size(subset.Selected) > 0);
    },
  },
};
</script>
<style scoped>
.grow:hover {
  -webkit-transform: scale(1.3);
  -ms-transform: scale(1.3);
  transform: scale(1.3);
}
</style>
